(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["putaoyao-progressive-image"] && !Shopify.designMode) return;
  try {
    (() => {
  if (customElements.get('py-progressive-image')) return;
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      observer.unobserve(entry.target);
      entry.target.loadPreview();
    });
  }, { rootMargin: '1000px 0px', threshold: 0 }) : null;
  class ProgressiveImage extends HTMLElement {
    connectedCallback() { queueMicrotask(() => this.connectImage()); }
    connectImage() {
      if (!this.isConnected || this.controller) return;
      const img = this.querySelector('img');
      if (!img) return;
      this.image = img;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      img.addEventListener('load', () => { this.fullFailed = false; this.reveal(); }, { signal });
      img.addEventListener('error', () => {
        this.fullFailed = true;
        clearTimeout(this.clearPreview);
        this.classList.remove('py-preview-ready');
        // Hide a failed full image only when a verified preview can replace it.
        this.classList.toggle('py-preview-waiting', !!this.previewReady);
        this.loadPreview();
      }, { signal });
      if (img.complete && img.naturalWidth > 0) { this.reveal(); return; }
      // Keep the native image visible until a usable preview is decoded.
      this.classList.remove('py-preview-waiting');
      if (img.loading === 'eager' || !observer) this.loadPreview();
      else observer.observe(this);
    }
    loadPreview() {
      if (!this.isConnected || this.classList.contains('py-preview-ready')) return;
      const source = this.dataset.previewUrl;
      if (!source || this.previewLoading) return;
      if (this.previewReady) { this.showPreview(source); return; }
      this.previewLoading = true;
      const lifecycle = this.controller;
      const preview = new Image();
      this.preview = preview;
      preview.decoding = 'async';
      preview.fetchPriority = 'low';
      preview.onload = async () => {
        try { if (preview.decode) await preview.decode(); } catch (_) {}
        if (!this.isConnected || this.controller !== lifecycle) return;
        this.previewLoading = false;
        if (this.classList.contains('py-preview-ready')) return;
        if (this.image.complete && this.image.naturalWidth > 0) { this.reveal(); return; }
        if (!preview.naturalWidth) { this.previewFailed(); return; }
        this.previewReady = true;
        this.showPreview(source);
      };
      preview.onerror = () => {
        if (this.isConnected && this.controller === lifecycle) this.previewFailed();
      };
      preview.src = source;
    }
    showPreview(source) {
      const style = getComputedStyle(this.image);
      this.style.backgroundPosition = style.objectPosition || '50% 50%';
      this.style.backgroundSize = style.objectFit === 'contain' ? 'contain' : 'cover';
      this.style.backgroundImage = `url(${JSON.stringify(source)})`;
      // Never delay the LCP image; other images crossfade over the decoded preview.
      if (this.image.getAttribute('fetchpriority') !== 'high' || this.fullFailed) {
        this.classList.add('py-preview-waiting');
      }
    }
    previewFailed() {
      this.previewLoading = false;
      this.previewReady = false;
      this.classList.remove('py-preview-waiting');
      this.style.backgroundImage = 'none';
    }
    async reveal() {
      const img = this.image;
      if (!img || !img.complete || !img.naturalWidth) return;
      const lifecycle = this.controller;
      const source = img.currentSrc || img.src;
      try { if (img.decode) await img.decode(); } catch (_) {}
      if (!this.isConnected || this.controller !== lifecycle || !img.naturalWidth || source !== (img.currentSrc || img.src)) return;
      observer?.unobserve(this);
      this.classList.remove('py-preview-waiting');
      this.classList.add('py-preview-ready');
      clearTimeout(this.clearPreview);
      this.clearPreview = setTimeout(() => { this.style.backgroundImage = 'none'; }, 220);
    }
    disconnectedCallback() {
      observer?.unobserve(this);
      this.controller?.abort();
      this.controller = null;
      if (this.preview) { this.preview.onload = null; this.preview.onerror = null; }
      this.preview = null;
      this.previewLoading = false;
      this.previewReady = false;
      this.classList.remove('py-preview-waiting');
      clearTimeout(this.clearPreview);
    }
  }
  customElements.define('py-progressive-image', ProgressiveImage);
})();
  } catch(e) { console.error(e); }
})();

})();
